export default "__VITE_ASSET__742e575f__"